module.exports = __webpack_public_path__ + "img/a.975cdb38.jpg";